import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../index';

const selectState = (state: AppState) => state.messageTemplates;
export const selectMessageTemplatesState = createSelector(selectState, (state) => state);
export const selectMessageTemplatesFilters = createSelector(
  selectMessageTemplatesState,
  ({ filters }) => filters,
);
